module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo_sc_mob-459b8d6b5ad99049cdaed1f9f783dbc3.png";